import {useTheme} from "@material-ui/core";
import Box from "../Box";
import React from "react";
import PropTypes from "prop-types";

export default function CircleIndicator({sequence}) {
    const theme = useTheme();
    const left = ((sequence + 1) < 10) ? "-0.5rem" : "-0.3rem"
    return (
        <Box position="absolute" borderRadius="50%" borderColor={theme.palette.secondary.main} border="2px solid" height="1.6rem" width="1.6rem" left={left} />
    )
}

CircleIndicator.propTypes = {
    sequence: PropTypes.number
}